import { type ReactNode } from "react";
import { AccessContext, useCheckAccess } from "./context.ts";

export function CheckAccessProvider(props: { children: ReactNode }) {
  const result = useCheckAccess();
  return <AccessContext value={result}>{props.children}</AccessContext>;
}

/**
 * Invokes unlocks check when rendered.
 *
 * This is useful when you want to re-run unlocks check after something might
 * have changed them (like a purchase).
 */
export function CheckAccess() {
  useCheckAccess();
  return null;
}
